import React, { Component } from 'react';
import close from "../images/icons/close.png"
import pwd from "../images/lokal/pwd.png"
import $ from "jquery";
import jwt from 'jsonwebtoken'
import config from '../config'
import { getData ,report } from '../services';
import TermsAndCondition from "./termsAndCondition"
export default class signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailId: '',
      password: '',
      mobileNumber: '',
      txtFirstName: '',
      otpSignUp: '',
      countryData : [], 
      selectedCountry:"",
      isChecked: true,
      errors: {},
      fields: {},
      otpFlag: "false",
      placeholderText: 'Email Id',
      placeholderTextPassword: 'Password',
      resendButton: false,
      resendButtonValue: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMobileChange = this.handleMobileChange.bind(this);
    this.handleOtpChange = this.handleOtpChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.forgotPswrdClick = this.forgotPswrdClick.bind(this);
    this.resendOtp = this.resendOtp.bind(this);
  }
  resendOtp() {
    $(".OtpMsg").text("");
    if (this.state.mobileNumber.length === 10) {
      $("#resendOTPSign").hide();
      this.setState({
        resendButton: true,
        resendButtonValue: false
      })
      let mobileNumber = this.state.mobileNumber;
      let otp = this.state.otpSignUp;
      let siteId = localStorage.getItem('siteId');
      let type = "SignUp";
      const postData = {
        functionName: "userverification/sms",
        siteIdInSms: siteId,
        typeInSms: type,
        mobileNumberInSms: mobileNumber,
        otpInSms: ""
      }
      getData(postData).then((data) => {
        if (data.data.success === "1") {
          $(".signErrorMsg").text("");
          $(".OtpMsg").text("OTP has been sent to your Mobile Number");
        }
      })
    }
  }
  loginOnClick() {
    $(".signUpPopUp").hide();
    $(".loginPopUp").show();
    $("#username").focus();
  }
  forgotPswrdClick() {
    $(".forgotPasswordPopUp").show();
    $(".loginForgotHide").hide();
    $("#emailorMob").focus();
  }
  componentDidMount() {
    this.generateCaptcha();
    this.countryListing();
    $("#changeCaptchaCodeForImage").click(function () {
      var code = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++)
        code += possible.charAt(Math.floor(Math.random() * possible.length)) + ' ';
      $("#lblCaptchaCode").html(code);
    });
    $(".loginClose").click(function () {
      $(".signUpPopUp").hide();
    });
  }
  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  }
  generateCaptcha() {
    var code = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++)
      code += possible.charAt(Math.floor(Math.random() * possible.length)) + ' ';
    $("#lblCaptchaCode").html(code);
  }
  _handleKey = (e) => {
    if (e.key === 'Enter') {
      document.getElementById("btnSignUp1").click();
    }
  }
  onSubmit = (event) => {

    $(".signErrorMsg").text("");
    let siteId = localStorage.getItem('siteId');
    let themeId = localStorage.getItem('themeId')
    let emailId = this.state.emailId;
    let password = this.state.password;
    let txtFirstName = this.state.txtFirstName;
    let mobileNumber = this.state.mobileNumber;
    var signErrorMsg = "";
    let formIsValid = false;
    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!txtFirstName) {
      signErrorMsg = "Name Required";
      $("#txtFirstName").focus();
      formIsValid = false;
    }
    else if(this.state.selectedCountry == ""){
      signErrorMsg = "Please choose country code";
      // $("#txtFirstName").focus();
      formIsValid = false;
    }
    else if (!mobileNumber) {
      signErrorMsg = "Mobile Number Required";
      $("#mobileNumber").focus();
      $(".OtpMsg").text("");
      formIsValid = false;
    }
    else if (!mobileNumber.match(/^[0-9]+$/)) {
      signErrorMsg = "Enter a valid Mobile Number";
      $("#mobileNumber").focus();
      $(".OtpMsg").text("");
      formIsValid = false;
    }
    else if (this.state.selectedCountry !== "1" && emailId === "") {
      signErrorMsg = "Email Address Required";
      $("#emailId").focus();
      $(".OtpMsg").text("");
      formIsValid = false;
    }
    else if (emailId !== "" && characters.test(emailId) === false) {
      signErrorMsg = "Invalid Email Address";
      $("#emailId").focus();
      $(".OtpMsg").text("");
      formIsValid = false;
    }
    else if (this.state.selectedCountry !== "1" && password === "") {
      signErrorMsg = "Password Required";
      $("#password").focus();
      $(".OtpMsg").text("");
      formIsValid = false;
    }
   
    else {
      formIsValid = true;
    }
    if (!formIsValid) {
      $(".signErrorMsg").text(signErrorMsg);
      return false;
    }
    else {
      $("#btnSignUpProcessing").show();
      $("#btnSignUp").hide();
      var randomNumber = new Date().getTime();
      // if (emailId === "") {
      //   this.setState({
      //     emailId: randomNumber.toString() + '@mail.com'
      //   })
      // }
      if (password === "") {
        this.setState({
          password: randomNumber.toString()
        })
      }
      $(".signErrorMsg").text("");
      const token = jwt.sign({
        txtFirstName: this.state.txtFirstName,
        emailId: this.state.emailId,
        mobileNumber: this.state.mobileNumber,
        password: this.state.password,
        countryId:this.state.selectedCountry,
        isTermsAccepted: this.state.isChecked
      }, config.jwtSecret);
      console.log("token,,,,,,,,,,,,,,,,,,,,,,",this.state.selectedCountry)
      const postData = {
        functionName: "usersignup/signUp",
        token: token,
        siteId: siteId,
        otpFlag:this.state.selectedCountry != '1' ? 'true' :  this.state.otpFlag
      }
      getData(postData).then((data) => {
        if (data.data.success === "0") {
          $("#btnSignUpProcessing").hide();
          $("#btnSignUp").show();
          $(".signErrorMsg").text(data.data.errorMessage);
        }
        else {
          if(data.data.success === "1" && this.state.selectedCountry !== "1")
          {
            localStorage.setItem('userId', data.data.result.userData[0].userId);
      localStorage.setItem('displayName', data.data.result.userData[0].displayName);
      localStorage.setItem('role', data.data.result.userData[0].userRole);
      window.sessionStorage.setItem('mobileNumber', data.data.result.userData[0].mobileNumber);
      window.sessionStorage.setItem('emailId', data.data.result.userData[0].emailId);
      if (window.sessionStorage.getItem('loginFromCart')) {
        window.location.href = "/OrderSummary";
        window.sessionStorage.removeItem('loginFromCart');
      }
      else {
        if (window.sessionStorage.getItem('mainCategoryId') === '5') {
          window.location.href = "/restaurantListing/0/0/";
        }
        else if (window.sessionStorage.getItem('mainGroupCategory') === '8') {
          if (themeId === '38' || themeId === '2') {
            window.location.href = "/";
          }
          else {
            window.location.href = "/cmItemListing/0/0/0/";
          }
        }
        else if (themeId === '34' || themeId === '29'|| themeId === '4' || themeId === '1') {
          window.location.href = '/'
        }
        else {
          window.location.href = '/home'
        }
      }
          }
          else if (data.data.success === "1" && this.state.otpFlag === "false" && this.state.otpSignUp === '' && this.state.resendButton === false && this.state.selectedCountry === "1") {
            let mobileNumber = this.state.mobileNumber;
            let otp = this.state.otpSignUp;
            let siteId = localStorage.getItem('siteId');
            let type = "SignUp";
            const postData = {
              functionName: "userverification/sms",
              siteIdInSms: siteId,
              typeInSms: type,
              mobileNumberInSms: mobileNumber,
              otpInSms: otp
            }
            getData(postData).then((data) => {
              if (data.data.success === "1") {
                $("#btnSignUpProcessing").hide();
                $("#btnSignUp").show();
                $(".otpSignUp").show();
                this.setState({
                  resendButtonValue: true,
                  resendButton: true
                })
                setTimeout(function () { $("#resendOTPSign").show(); }, 30000);
                $(".OtpMsg").text("OTP has been sent to your Mobile Number");
              }
            })
          }
          else if (data.data.success === "1" && this.state.otpFlag === "false" && this.state.otpSignUp !== '') {
            $("#btnSignUpProcessing").hide();
            $("#btnSignUp").show();
            let mobileNumber = this.state.mobileNumber;
            let otp = this.state.otpSignUp;
            let siteId = localStorage.getItem('siteId');
            let type = "SignUp";
            const postData = {
              functionName: "userverification/sms",
              siteIdInSms: siteId,
              typeInSms: type,
              mobileNumberInSms: mobileNumber,
              otpInSms: otp
            }
            getData(postData).then((data) => {
              if (data.data.success === "1") {
                this.lastcall(token,siteId)
                // const postData = {
                //   functionName: "usersignup/signUp",
                //   token: token,
                //   siteId: siteId,
                //   otpFlag: "true"
                // }
                // getData(postData).then((data) => {
                //   localStorage.setItem('userId', data.data.result.userData[0].userId);
                //   localStorage.setItem('displayName', data.data.result.userData[0].displayName);
                //   localStorage.setItem('role', data.data.result.userData[0].userRole);
                //   window.sessionStorage.setItem('mobileNumber', data.data.result.userData[0].mobileNumber);
                //   window.sessionStorage.setItem('emailId', data.data.result.userData[0].emailId);
                //   if (window.sessionStorage.getItem('loginFromCart')) {
                //     window.location.href = "/OrderSummary";
                //     window.sessionStorage.removeItem('loginFromCart');
                //   }
                //   else {
                //     if (window.sessionStorage.getItem('mainCategoryId') === '5') {
                //       window.location.href = "/restaurantListing/0/0/";
                //     }
                //     else if (window.sessionStorage.getItem('mainGroupCategory') === '8') {
                //       if (themeId === '38' || themeId === '2') {
                //         window.location.href = "/";
                //       }
                //       else {
                //         window.location.href = "/cmItemListing/0/0/0/";
                //       }
                //     }
                //     else if (themeId === '34' || themeId === '29'|| themeId === '4' || themeId === '1') {
                //       window.location.href = '/'
                //     }
                //     else {
                //       window.location.href = '/home'
                //     }
                //   }
                // });
              }
              else {
                $("#btnSignUpProcessing").hide();
                $("#btnSignUp").show();
                $(".OtpMsg").text("")
                $(".signErrorMsg").text("Incorrect OTP");
                return false;
              }
            })
          }
          
          else {
            $("#btnSignUpProcessing").hide();
            $("#btnSignUp").show();
            $(".OtpMsg").text("")
            $(".signErrorMsg").text("OTP Required");
            return false;
          }
        }
      });
    }
  }
  lastcall = (token,siteId) => {
    let themeId = localStorage.getItem('themeId')
    const postData = {
      functionName: "usersignup/signUp",
      token: token,
      siteId: siteId,
      otpFlag: "true"
    }
    getData(postData).then((data) => {
      localStorage.setItem('userId', data.data.result.userData[0].userId);
      localStorage.setItem('displayName', data.data.result.userData[0].displayName);
      localStorage.setItem('role', data.data.result.userData[0].userRole);
      window.sessionStorage.setItem('mobileNumber', data.data.result.userData[0].mobileNumber);
      window.sessionStorage.setItem('emailId', data.data.result.userData[0].emailId);
      if (window.sessionStorage.getItem('loginFromCart')) {
        window.location.href = "/OrderSummary";
        window.sessionStorage.removeItem('loginFromCart');
      }
      else {
        if (window.sessionStorage.getItem('mainCategoryId') === '5') {
          window.location.href = "/restaurantListing/0/0/";
        }
        else if (window.sessionStorage.getItem('mainGroupCategory') === '8') {
          if (themeId === '38' || themeId === '2') {
            window.location.href = "/";
          }
          else {
            window.location.href = "/cmItemListing/0/0/0/";
          }
        }
        else if (themeId === '34' || themeId === '29'|| themeId === '4' || themeId === '1') {
          window.location.href = '/'
        }
        else {
          window.location.href = '/home'
        }
      }
    });
  }
  handleInputChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }
  handleMobileChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ mobileNumber: e.target.value })
    }
  }
  handleOtpChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ otpSignUp: e.target.value })
    }
  }
  handleCountryChange = (event) => {
    this.setState({ selectedCountry: event.target.value,
       placeholderText: `Email Id ${event.target.value == '1' ? '(Optional)' : ''}`,
       placeholderTextPassword: `Password ${event.target.value == '1' ? '(Optional)' : ''}`,
     });
  };
  countryListing() {
    const postData = {
        functionName: "addState",
        cmbStatus: "",
        cmbCategory: "",
        txtInput: "",
        offset: "0",
        max: "10"
    }
    report(postData).then((data) => {
      console.log("country list ",data)
        if (data.data.success === "1") {
            this.setState({
                countryData: data.data.result.countryData,
            });
        }
    })
}
  render() {
    let themeId = localStorage.getItem('themeId')
    return (
      <div>
        <div className="popOverlay loginForgotHide"></div>
        <div className="loginPop loginForgotHide">
          <div className="loginHead">
            <span className="loginClose"><img src={close} alt="" /></span>
            <div className="loginText">
              Get Started!
            </div>
          </div>
          <div className="loginForm gsa-loginforms">
            <form>
              <div className="errorMsg signErrorMsg" id="signErrorMsg"></div>
              <div className="errorMsg OtpMsg"></div>
              <div className="loginFormList" >
                <input type="text" tabIndex='1' autoComplete="off" className="inputTextField" id="txtFirstName" name="txtFirstName" onChange={this.handleInputChange} onKeyDown={this._handleKey} required placeholder="Name" />
              </div>
              <div className="loginFormList" >
                <div className="row p-0">
                  <div className="col-5 pr-0">
                  <select
          className="inputTextField px-2"
          onChange={this.handleCountryChange}
          value={this.state.selectedCountry}
        >
          <option value="">Select Country</option> {/* Default option */}
          {this.state.countryData.map((country) => (
            <option key={country.id} value={country.id}>
              {country.name} {country.country_code && `(${country.country_code})`}
            </option>
          ))}
        </select>
                  </div>
                  <div className="col-7">
                  <input type="text" tabIndex='2' autoComplete="off" className="inputTextField" id="mobileNumber" 
                  name="mobileNumber" value={this.state.mobileNumber} maxLength={10} onKeyDown={this._handleKey} 
                  placeholder="Mobile Number" onChange={this.handleMobileChange} required />
                  </div>
                </div>
                
              </div>
              <div className="loginFormList otpSignUp " style={{ display: 'none' }}>
                <input type="text" autoComplete="off" tabIndex='3' className="inputTextField otpTextField" id="otpSignUp" name="otpSignUp" placeholder="OTP" value={this.state.otpSignUp} onKeyDown={this._handleKey} onChange={this.handleOtpChange} required />
                <span id="resendOTPSign" className="otpButton" onClick={this.resendOtp} style={{ display: 'none' }}>Resend OTP</span>
              </div>
              <div className="loginFormList" >
                <input type="text" tabIndex='4' onKeyDown={this._handleKey} autoComplete="off" className="inputTextField" id="emailId" name="emailId" placeholder={this.state.placeholderText}  onChange={this.handleInputChange} />
              </div>
              <div className="loginFormList" >
                <input type="password" tabIndex='5' onKeyDown={this._handleKey} className="inputTextField" id="password" name="password" placeholder={this.state.placeholderTextPassword}  onChange={this.handleInputChange} />
                <img src={pwd} alt="" className="gsa-pwd-img" />
              </div>
              <div className="loginFormList loginFormListText"  >
                <span className="checkBoxSquare">
                  <input type="checkbox" id="chkIsOpt" tabIndex='6' checked={this.state.isChecked}
                    onChange={this.toggleChange}
                    name="chkIsOpt" value={this.state.isChecked} /><label htmlFor="chkIsOpt"></label>
                </span>
                <span className="agree-terms">I agree to receive promotional content and to be added to a whatsapp group</span>
              </div>
              <div className="formButton" id="btnSignUp"><span tabIndex='7' className="loginButton" id="btnSignUp1" onClick={this.onSubmit} value="Sign Up" >Sign Up</span></div>
              <div className="formButton" style={{ display: 'none' }} id="btnSignUpProcessing"><span tabIndex='7' style={{ cursor: 'default', background: '#b3b3b3' }} className="loginButton" value="Sign Up" >Processing...</span></div>
            </form>
            <div className="registrationText">Already have an account? <span onClick={this.loginOnClick}>Login</span></div>
            <div className="registrationText registrationTextBottom">By clicking Sign Up, you agree to MyyShopp's User Agreement, Privacy Policy and Cookie Policy
              {(themeId !== '34' && themeId !== '29' && themeId !== '4') ? <TermsAndCondition></TermsAndCondition> : ""}
            </div>
          </div>
        </div>
        <div className="popupWrap forgotPasswordPopUp">
          {/* <ForgotPassword></ForgotPassword> */}
        </div>
      </div>
    )
  }
}
